<template>
  <div id="ServiceProviderPrice" class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>爬虫执行情况</el-breadcrumb-item>
      <el-breadcrumb-item>品牌用量详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <section class="seaerch-wrapper">
      <el-form class="search-form" style="margin-left: -30px;" :label-width="formLabelWidth">
        <el-form-item label="平台">
          <el-select v-model="queryParams.platform" placeholder="请选择" clearable size="small">
            <el-option key="淘宝" label="淘宝" value="淘宝"></el-option>
            <el-option key="京东" label="京东" value="京东"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务商">
          <el-select v-model="queryParams.provider" placeholder="请选择" clearable size="small">
            <el-option key="求美" label="求美" value="求美"></el-option>
            <el-option key="喜大" label="喜大" value="喜大"></el-option>
            <el-option key="悠悠乐" label="悠悠乐" value="悠悠乐"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="search-btn" @click="theQuery()">查询</el-button>
        </el-form-item>
      </el-form>
    </section> -->
    <div class="page">
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="平台" prop="platform">
        </el-table-column>
        <el-table-column label="服务商" prop="provider">
        </el-table-column>
        <el-table-column label="单价（分）" prop="price">
        </el-table-column>
        <el-table-column label="修改日期" prop="createtime">
          <template slot-scope="scope">
            {{ scope.row.updatetime | fullTimeShort }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit-outline"
              @click="oneStep(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 编辑 -->
    <div id="dialog">
      <el-dialog title="编辑" :visible.sync="theEditorShow" width="640px" :close-on-click-modal='false'>
        <el-form :model="form" :rules="rules" ref="ruleForm" style="margin-top: 20px;">
          <el-form-item label="平台" :label-width="formLabelWidth">
            <el-input v-model="form.platform" style="width: 420px;" disabled size="small"></el-input>
          </el-form-item>
          <el-form-item label="服务商" :label-width="formLabelWidth">
            <el-input v-model="form.provider" style="width: 420px;" disabled size="small"></el-input>
          </el-form-item>
          <el-form-item label="单价（分）" :label-width="formLabelWidth" prop="price">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form.price"
              autocomplete="off" style="width: 420px;" placeholder="请填写"
              size="small"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')" size="small">确 定</el-button>
          <el-button @click="theEditorShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取
            消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import aes from "../../libs/aes";
import pagination from "../../components/dataTable/pagination";
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      queryParams: {
        platform: '',
        provider: '',
      },
      searchformDate: [],
      formLabelWidth: '120px',
      tableData: [],
      dataId: '',
      useDisble: false,
      theEditorShow: false,
      rules: {
        price: [
          { required: true, message: '请输入单价', trigger: 'blur' },
        ],
      },
      form: {
        platform: '',
        provider: '',
        price: '',
      },
    }
  },
  mounted() {
    this.theQuery();
  },
  methods: {
    theQuery() {
      let params = {}
      if (this.queryParams.platform.length > 0) {
        params.platform = this.queryParams.platform.join(',')
      }
      if (this.queryParams.provider) {
        params.provider = this.queryParams.provider
      }
      fetch({
        url: "hcm/iprBmcTotalCount/selectIprBmcTotalPriceList",
        method: "post",
        noFormat: true,
        params: params,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.tableData = data;
        }
      }).catch(err => {

      })
    },
    oneStep(data) {
      this.form = data;
      this.theEditorShow = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            id: this.form.id,
            price: this.form.price
          }
          fetch({
            url: "hcm/iprBmcTotalCount/updateIprBmcTotalPrice",
            method: "post",
            data: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let { data } = res
            if (res.status == '10000') {
              this.theEditorShow = false
              this.theQuery();
            }
          }).catch(err => {

          })
        } else {
          return false;
        }
      });
    },

  },
  components: {
    pagination
  }
}
</script>
<style scoped lang="scss">
.page {
  padding: 20px;
  margin-top: 10px;
  background-color: white;
}
</style>
<style lang="scss">
#ServiceProviderPrice {
  .el-table th {
    background-color: #f3f7ff !important;
  }

  .el-table__empty-text {
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }

  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
  }

  .el-button+.el-button {
    margin-left: 1px;
  }

  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }

  .el-button--TheCustom:hover {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }

  .el-button--primary {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }

  .el-button--primary:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
}
</style>
